$('.js-toggle-profile-text').click(() => {
  $('.photographer-profile-info-text').slideToggle();
});
